import { AddClient } from '@src/clients/AddClient';
import type { AdminClientFormSchema } from '@src/clients/schemas/AdminClientFormSchema';
import { IsAgencyField } from '@src/clients/schemas/AdminClientFormSchema';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import { ControllerFormCheckbox } from '@src/orders/PermitFormSections/FormCheckbox';
import type { Control } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import type * as yup from 'yup';

export const AdminAddClient = () => {
  const navigate = useNavigate();
  const navigateToClients = () => navigate('/clients');
  return (
    <AddClient
      onCancel={navigateToClients}
      onAddClientSuccess={navigateToClients}
      AdditionalDetails={({
        control,
      }: {
        control: Control<yup.InferType<typeof AdminClientFormSchema>>;
      }) => (
        <Stack direction="row" gap={theme.spacing['6']}>
          <ControllerFormCheckbox
            control={control}
            fieldName={IsAgencyField.fieldName}
          />
        </Stack>
      )}
    />
  );
};
